import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate, useOutletContext } from "react-router-dom";
import Pagination from "react-js-pagination";
import moment from "moment";

import useQueryString from "../../../../hooks/useQueryString";

import List from "./common/list";
import { FaBars } from "react-icons/fa6";

export default function Notice() {
  const navigate = useNavigate();
  const queryPage = Number(useQueryString("page"));

  const { url, cmpnyNo, theme } = useOutletContext();
  const [notices, setNotices] = useState([]);
  const [currentPage, setCurrentPage] = useState(queryPage || 0);
  const [totalCount, setTotalCount] = useState(0);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (cmpnyNo) {
      getNotice();
    } else {
      setIsLoading(false);
    }
  }, [cmpnyNo]);

  useEffect(() => {
    navigate(`/shop/${url}/shoppingNotice?page=${currentPage}`);
  }, [currentPage]);

  const getNotice = async (page = queryPage || 0) => {
    setCurrentPage(page);
    const req = {
      gbn: "N",
      delYn: "N",
      cmpnyNo: cmpnyNo,
      offset: 10 * page,
      pageNumber: page,
      pageSize: 10,
      paged: true,
    };

    const response = await axios.post("/api/noticeList", req);
    const res = response.data;

    setIsLoading(false);
    setNotices(res.content);
    setTotalCount(res.totalElements);
  };

  const nextPage = (num) => {
    getNotice(num - 1);
  };

  const header = [
    { name: "번호", key: "noticeNo" },
    { name: "카테고리", key: "noticeCl" },
    { name: "제목", key: "noticeSj" },
    { name: "글쓴이", key: "createMberId" },
    {
      name: "등록일",
      key: "createDt",
      content: (item) => (
        <span className="createDt">
          {moment(item.updateDt || item.createDt).format("YYYY-MM-DD HH:mm")}
        </span>
      ),
    },
  ];

  const moveToPage = (item) => {
    navigate(`/shop/${url}/shoppingNoticeView/${item.noticeNo}`);
  };

  return (
    <>
      <div className="count">
        <FaBars />
        공지사항
        <strong> {totalCount}</strong>
        개가 등록되어 있습니다.
      </div>
      <List
        data={notices}
        header={header}
        type="공지사항"
        clickEvent={moveToPage}
        className="notice"
      />
      {notices && notices.length > 0 && (
        <Pagination
          activePage={currentPage + 1}
          itemsCountPerPage={10}
          totalItemsCount={totalCount}
          pageRangeDisplayed={3}
          prevPageText={"‹"}
          nextPageText={"›"}
          onChange={nextPage}
        />
      )}
    </>
  );
}
